export const CONDITIONS_AND_FEES = [
  {
    name: 'conditionsAndFees.dialog.block.general.title',
    items: [
      {
        key: 'conditionsAndFees.dialog.block.general.item.openAcc.key',
        value: 'conditionsAndFees.dialog.block.general.item.openAcc.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.general.item.openCrypto.key',
        value: 'conditionsAndFees.dialog.block.general.item.openCrypto.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.general.item.openMaster.key',
        value: 'conditionsAndFees.dialog.block.general.item.openMaster.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.general.item.openCardWallet.key',
        value: 'conditionsAndFees.dialog.block.general.item.openCardWallet.value',
      },
    ],
  },
  {
    name: 'conditionsAndFees.dialog.block.card.title',
    items: [
      {
        key: 'conditionsAndFees.dialog.block.card.item.first10Cards.key',
        value: 'conditionsAndFees.dialog.block.card.item.first10Cards.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.card.item.after10CardsInEur.key',
        value: 'conditionsAndFees.dialog.block.card.item.after10CardsInEur.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.card.item.after10CardsInUsd.key',
        value: 'conditionsAndFees.dialog.block.card.item.after10CardsInUsd.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.card.item.blockCard.key',
        value: 'conditionsAndFees.dialog.block.card.item.blockCard.value',
      },
    ],
  },
  {
    name: 'conditionsAndFees.dialog.block.topUpCrypto.title',
    items: [
      {
        key: 'conditionsAndFees.dialog.block.topUpCrypto.item.fromPartners.key',
        value: 'conditionsAndFees.dialog.block.topUpCrypto.item.fromPartners.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.topUpCrypto.item.fromOutside.key',
        value: 'conditionsAndFees.dialog.block.topUpCrypto.item.fromOutside.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.topUpCrypto.item.masterTopUpEur.key',
        value: 'conditionsAndFees.dialog.block.topUpCrypto.item.masterTopUpEur.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.topUpCrypto.item.masterTopUpUsd.key',
        value: 'conditionsAndFees.dialog.block.topUpCrypto.item.masterTopUpUsd.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.topUpCrypto.item.cardWalletTopUp.key',
        value: 'conditionsAndFees.dialog.block.topUpCrypto.item.cardWalletTopUp.value',
      },
    ],
  },
  {
    name: 'conditionsAndFees.dialog.block.currencyExchange.title',
    items: [
      {
        key: 'conditionsAndFees.dialog.block.currencyExchange.item.cryptoCrypto.key',
        value: 'conditionsAndFees.dialog.block.currencyExchange.item.cryptoCrypto.value',
      },
      {
        key: 'conditionsAndFees.dialog.block.currencyExchange.item.cryptoFiat.key',
        value: 'conditionsAndFees.dialog.block.currencyExchange.item.cryptoFiat.value',
      },
    ],
  },
  {
    name: 'conditionsAndFees.dialog.block.payout.title',
    items: [
      {
        key: 'conditionsAndFees.dialog.block.payout.item.payoutOutside.key',
        value: 'conditionsAndFees.dialog.block.payout.item.payoutOutside.value',
      },
    ],
  },
];
